import { Subject } from 'rxjs'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class ActiveTopMasterKeyService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  activeTopMasterKey = new Subject<number | null>()
  activeTopMasterKey$ = this.activeTopMasterKey.asObservable()

  getActiveTopMasterKey() {
    return this.activeTopMasterKey$
  }

  setActiveTopMasterKey(id: number) {
    this.activeTopMasterKey.next(id)
  }
}
